<template>
  <v-tooltip
    v-model="tooltipOpen"
    activator="parent"
    location="bottom"
    :open-on-hover="false"
    :open-on-focus="false"
    open
    max-width="300"
    :class="$style.tooltip"
  >
    <template #default>
      <div>
        با هر بلوط در سنجاب، می‌توانید یک گزارش کامل و جامع از پیج مورد نظر خود
        دریافت کنید.
      </div>
    </template>
  </v-tooltip>
  <div
    :class="$style.creditNumberContainer"
    @click="tooltipOpen = !tooltipOpen"
  >
    <img :src="oakIcon" alt="oak" width="38px" class="ml-2" />
    <div :class="$style.textWrapper">
      <span :class="$style.text">{{ pointStore.currentPoint }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import oakIcon from "../../../assets/icons/oak.png";
import { ref, useCssModule, onMounted, onUnmounted } from "vue";

const $style = useCssModule();
const pointStore = usePointStore();
const tooltipOpen = ref<boolean>(false);

const handleClickOutsideCreditNumberContainer = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  if (!target.closest(`.${$style.creditNumberContainer}`)) {
    tooltipOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutsideCreditNumberContainer);
});

onUnmounted(() => {
  document.removeEventListener(
    "click",
    handleClickOutsideCreditNumberContainer
  );
});
</script>

<style module lang="scss">
.creditNumberContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;

  .textWrapper {
    background-color: $primary;
    border-radius: $space-s;
    position: absolute;
    top: 4px;
    left: 38px;
    min-width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: $space-s;

    .text {
      color: $white;
      font-size: $font-size-n;
      margin-top: $space-s;
      font-weight: 600;
    }
  }
}
</style>
